import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./index.css";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Mask from "../../services/mask";
import { Navigate, useNavigate, useParams } from "react-router";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import ImgLoja from "../../assets/images/pngs/shop.png";
import { useLoad } from "../../context";
import DuploFator from "../../Components/DuploFator";
import { toast } from "react-toastify";
import escudo from "../../assets/images/pngs/escudo.png";
import { filterProductsByUserCategory } from "../../utils/categoryFilter";

export default function ProdutoTimeDeCraque() {
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [saldo, setSaldo] = useState(0);
  const [mostrarSaldo, setMostrarSaldo] = useState(false);
  const [produto, setProduto] = useState({});
  const paramsId = useParams().id;
  const [quantidade, setQuantidade] = useState(1);
  const [tipoModal, setTipoModal] = useState(0);
  const [vouchers, setVouchers] = useState(0);
  const { load, setLoad } = useLoad();
  const navigate = useNavigate();
  const [abrirDuploFator, setAbrirDuploFator] = useState(false);
  const [abrirModalNaoTecnico, setAbrirModalNaoTecnico] = useState(false);
  const [tokenAcesso, setTokenAcesso] = useState("");
  const [verificaAntes, setVerificaAntes] = useState(true);
  const [verificaFechamento, setVerificaFechamento] = useState(null);
  const categoriaProdutoEscolaDaMarcenaria =
    "98af45ca-12f1-430e-b6d2-1336dda30d5a";

  async function fnCarregarSaldo() {
    var init = {
      token: user.token,
      mes: "",
      ano: "",
    };
    try {
      let response = await ApiServices.apiPost("vitrineorder/saldo", init);
      setSaldo(response.data.balance);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }

  async function fnResgatar() {
    var init = {
      points: produto.pontos,
      productId: produto.produtoId,
      produtoResgate: {
        description: produto.titulo,
        points: produto.pontos,
        productId: produto.sku,
        qtde: Number(quantidade),
      },
      CodigoDuploFator: tokenAcesso,
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPostResgate("produto/resgate", init);
      const data = await response.json();

      if (data.statusCode == 200) {
        if (
          produto.produtoCategoria.produtoCategoriaId ===
          categoriaProdutoEscolaDaMarcenaria
        ) {
          setTipoModal(3); // Definindo o tipo de modal para 3 se a categoria corresponder
          setTimeout(() => {
            window.location.href =
              "https://cursos.escola.leosocial.org.br/amigo-leo"; // Coloque aqui o link para redirecionar
          }, 8000); // Espera de 6 segundos
        } else {
          setTipoModal(2); // Caso contrário, continua com o tipo de modal 2
        }

        setAbrirDuploFator(false);
        setVouchers(data.data.token);
      } else {
        toast.error(data.message);
        setAbrirDuploFator(false);

        if (data.data.token !== "null") {
          setTipoModal(1);
        }
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnProduto() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(
        "produto/de-produto-detalhe/" + paramsId
      );

      // Check if user has access to this product based on categories
      const filteredProducts = filterProductsByUserCategory([response.data]);
      console.log(filteredProducts);
      if (filteredProducts.length === 0) {
        // User doesn't have access to this product, redirect back
        navigate("/catalogo/vitrine-leo");
        return;
      }

      setProduto(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  function fnMostrarSaldo() {
    if (mostrarSaldo) {
      setMostrarSaldo(false);
    } else {
      setMostrarSaldo(true);
      fnCarregarSaldo();
    }
  }

  function getQuantidadeLimitada(quantidadeNova) {
    quantidadeNova = Number(quantidadeNova);

    if (
      produto.quantoPodeResgatar !== null &&
      quantidadeNova > produto.quantoPodeResgatar
    )
      quantidadeNova = produto.quantoPodeResgatar;

    return quantidadeNova;
  }

  useEffect(() => {
    fnCarregarSaldo();
    fnProduto();
    window.scrollTo(0.0, 0.0);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tokenAcesso != "") {
      fnResgatar();
    }
  }, [tokenAcesso]);
  // useEffect(() => {
  //   if (abrirDuploFator) {
  //     fnResgatar();
  //   }
  // }, [abrirDuploFator]);

  return (
    <div>
      {abrirDuploFator && (
        <DuploFator
          setAbrirDuploFator={setAbrirDuploFator}
          setTokenAcesso={setTokenAcesso}
          setVerificaAntes={setVerificaAntes}
          setVerificaFechamento={setVerificaFechamento}
        />
      )}

      <div className="d-flex justify-content-center mt-3 ">
        <div className="container containerProduto">
          <div className="row  d-flex justify-content-center ">
            <div className="col-md-12">
              <div className=" row d-flex justify-content-center">
                <div className="col-md-5 col-10 my-3 inicioDetalhe">
                  <img width={"100%"} src={produto.urlImagem} alt="" />
                </div>

                <div className="col-md-7 my-3">
                  <div className="">
                    <h5 className="">{produto.titulo}</h5>
                    <h6 className="">Ref: {produto.sku}</h6>
                    {produto?.valorAtual &&
                    produto?.campanhaStatus?.nome == "Em andamento" ? (
                      <div>
                        <div style={{ marginBottom: -10 }}>De:</div>
                        <s
                          style={{
                            fontWeight: 900,
                            fontSize: 20,
                            color: "#aaaaaa",
                          }}
                        >
                          {Mask.numeroPontos(produto.valorAtual?.toString())}
                        </s>
                        <div style={{ marginTop: -5, fontSize: 10 }}>
                          PONTOS
                        </div>
                        <hr style={{ width: "20%" }}></hr>
                      </div>
                    ) : null}
                    <div>Por:</div>
                    <h4 style={{ fontWeight: 900 }}>
                      {Mask.numeroPontos(produto.pontos?.toString())}
                    </h4>
                    <div style={{ marginTop: -15, fontSize: 15 }}>PONTOS</div>

                    <div className="row mt-3">
                      <div className="col-md-4 p-2">
                        <button
                          className="btn btn-secondary w-100"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          VOLTAR
                        </button>
                      </div>

                      {produto.quantoPodeResgatar !== null &&
                        produto.quantoPodeResgatar <= 0 && (
                          <div className="col-md-5 p-2">
                            <h5>Limite máximo de resgate já atingido.</h5>
                          </div>
                        )}

                      {(produto.quantoPodeResgatar === null ||
                        produto.quantoPodeResgatar > 0) &&
                        produto.jaDriblouMissao == false && (
                          <div className="col-md-4 p-2">
                            {!storage.get("gestaoMenu").voucher && (
                              <button
                                className="btn btn-warning w-100"
                                onClick={() => {
                                  const escalacao = storage.get(
                                    "USUARIO_TIME_DE_CRAQUE"
                                  )?.escalacao;
                                  const codi_cli = storage.get(
                                    "USUARIO_TIME_DE_CRAQUE"
                                  )?.login?.codi_cli;

                                  const isTecnico = escalacao?.find(
                                    (e) => e.codiCli == codi_cli
                                  )?.tecnico
                                    ? true
                                    : false;

                                  if (!isTecnico) {
                                    setAbrirModalNaoTecnico(true);
                                  } else {
                                    setAbrirDuploFator(true);
                                  }
                                }}
                              >
                                RESGATAR
                              </button>
                            )}
                          </div>
                        )}
                    </div>
                    <div className="row">
                      <div
                        className="col-12 d-flex align-items-center pt-3 mt-3"
                        style={{ borderTop: "solid 2px #eee" }}
                      >
                        {produto?.produtoCategoria?.produtoCategoriaId ===
                        categoriaProdutoEscolaDaMarcenaria ? (
                          <div>
                            Ao resgatar este produto, será gerado um voucher
                            para utilização no site da Escola da Marcenaria.{" "}
                            <a
                              href="https://escola.leosocial.org.br/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontWeight: "bold",
                                color: "blue",
                              }}
                            >
                              https://escola.leosocial.org.br/
                            </a>
                          </div>
                        ) : (
                          <>
                            <img
                              className="me-3"
                              width={50}
                              src={escudo}
                              alt=""
                            />
                            <div>
                              O resgate deste produto será de exclusividade dos
                              participantes da promoção <b>Time de Craques. </b>
                              Lembrando que este resgate não poderá ser
                              cancelado
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {produto.descricao && (
                <div className="descricaoDetalhe">
                  <h4>Descrição</h4>
                  <span>{produto.descricao}</span>
                </div>
              )}
              {produto.aplicacoes && (
                <div className="descricaoDetalhe">
                  <h4>Aplicações</h4>
                  <span>{produto.aplicacoes}</span>
                </div>
              )}
              {produto.capacidade && (
                <div className="descricaoDetalhe">
                  <h4>Especificações</h4>
                  <span>{produto.capacidade}</span>
                </div>
              )}
              {produto.caracteristicas && (
                <div className="descricaoDetalhe">
                  <h4>Características</h4>
                  <span>{produto.caracteristicas}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {/* MODAL */}
      {/* MODAL */}
      <Modal
        keepMounted
        open={tipoModal != 0}
        onClose={() => setTipoModal(0)}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          className="configModal"
          style={{
            minWidth: 400,
            maxWidth: 500,
            color: "#222",
            padding: "20px",
            borderRadius: 16,
            background: "#fff",
            boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
            margin: "0 auto",
          }}
        >
          <div className="d-flex justify-content-end pointer">
            <CloseIcon
              onClick={() =>
                tipoModal === 2
                  ? navigate("/catalogo/vitrine-leo")
                  : setTipoModal(0)
              }
            />
          </div>
          {tipoModal == 1 && (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  color: "#dc3545",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 16,
                }}
              >
                Que pena! Você não tem pontos suficientes para resgatar este produto.
              </div>
              <SentimentVeryDissatisfiedIcon
                style={{ color: "#dc3545", fontSize: 80, marginBottom: 20 }}
              />
              <div
                style={{
                  fontSize: 16,
                  color: "#666",
                  marginBottom: "24px",
                  lineHeight: "1.5",
                }}
              >
                Continue comprando para juntar mais pontos.
              </div>
            </div>
          )}
          {tipoModal == 2 && (
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{
                padding: "32px 16px",
                background: "#f8f9fa",
                borderRadius: 16,
                boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                minWidth: 350,
                maxWidth: 500,
                margin: "0 auto",
              }}
            >
              <div
                style={{
                  color: "#3CB043",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 8,
                  textAlign: "center",
                }}
              >
                É GOL! Parabéns!
              </div>
              <img
                src={escudo}
                alt="Time de Craques"
                style={{ width: 90, margin: "12px 0" }}
              />
              <div
                style={{
                  background: "#fff",
                  border: "2px dashed #3CB043",
                  borderRadius: 10,
                  padding: "18px 24px",
                  margin: "16px 0 24px 0",
                  fontSize: 22,
                  fontWeight: 900,
                  color: "#3CB043",
                  letterSpacing: 2,
                  textAlign: "center",
                }}
              >
                Voucher:{" "}
                <span style={{ fontFamily: "monospace" }}>{vouchers}</span>
              </div>
              <div
                style={{
                  color: "#3CB043",
                  fontSize: 15,
                  margin: "18px 0 0 0",
                  fontWeight: 500,
                  textAlign: "center",
                  maxWidth: 400,
                }}
              >
                Você <b>cumpriu</b> mais uma missão no Time de Craques através
                do resgate 
                <span style={{ fontWeight: 700 }}>"Drible Pula Missão"</span>!
                <br />
                <br />
                Em breve, a missão estará marcada como concluída.
              </div>
              <div
                style={{
                  width: "100%",
                  margin: "18px 0",
                  borderTop: "1px solid #e0e0e0",
                }}
              />
              <div
                style={{
                  fontSize: 13,
                  color: "#222",
                  marginTop: 10,
                  fontWeight: 400,
                  textAlign: "center",
                }}
              >
                Lembrando que este resgate{" "}
                <b style={{ textDecoration: "underline" }}>não</b> poderá ser
                cancelado.
              </div>
            </div>
          )}
          {tipoModal == 3 && (
            <div className="row d-flex justify-content-center flex-column align-items-center " style={{ textAlign: "center" }}>
              <div
                style={{
                  color: "#28a745",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 16,
                }}
              >
                Parabéns! Resgate efetuado com sucesso
              </div>
              <CheckCircleOutlineIcon
                style={{ color: "green", fontSize: 100 }}
              />
              <div
                style={{
                  fontSize: 20,
                  marginTop: 30,
                  textAlign: "center",
                }}
              >
                Aguarde, você será direcionado para página da escola em alguns
                instantes, para confirmar seus dados digite seu Código:{" "}
                <b>{vouchers}</b>
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 900,
                  marginTop: 30,
                  textAlign: "center",
                }}
              >
                Prazo para cancelamento do voucher é de 7 dias úteis.
              </div>
            </div>
          )}
        </Box>
      </Modal>
      <Modal
        open={abrirModalNaoTecnico}
        onClose={() => setAbrirModalNaoTecnico(false)}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        className="d-flex align-items-center justify-content-center"
      >
        <Box
          className="d-flex flex-column align-items-center justify-content-center"
          style={{
            minWidth: 350,
            maxWidth: 400,
            width: "90%",
            textAlign: "center",
            borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
            background: "#fff",
            padding: 32,
            position: "relative",
            margin: "auto",
          }}
        >
          <div
            className="d-flex justify-content-end w-100"
            style={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon
              onClick={(e) => {
                e.stopPropagation();
                setAbrirModalNaoTecnico(false);
              }}
              style={{ cursor: "pointer", color: "#888" }}
            />
          </div>
          {/* Bandeira de impedimento estilo futebol */}
          <div
            style={{
              width: 70,
              height: 70,
              margin: "0 auto 20px auto",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="70" height="70" viewBox="0 0 70 70">
              {/* Mastro da bandeira */}
              <rect x="10" y="10" width="6" height="50" rx="3" fill="#888" />
              {/* Bandeira quadriculada */}
              <g>
                <rect
                  x="16"
                  y="10"
                  width="36"
                  height="24"
                  rx="3"
                  fill="#fff"
                  stroke="#222"
                  strokeWidth="2"
                />
                <rect x="16" y="10" width="18" height="12" fill="#ffcc00" />
                <rect x="34" y="22" width="18" height="12" fill="#ffcc00" />
                <rect x="34" y="10" width="18" height="12" fill="#e53935" />
                <rect x="16" y="22" width="18" height="12" fill="#e53935" />
                <rect
                  x="16"
                  y="10"
                  width="36"
                  height="24"
                  rx="3"
                  fill="none"
                  stroke="#222"
                  strokeWidth="2"
                />
              </g>
            </svg>
          </div>
          <Typography
            variant="h6"
            component="h2"
            style={{ fontWeight: 700, color: "#e53935", marginBottom: 8 }}
          >
            Impedimento!
          </Typography>
          <Typography
            variant="body1"
            style={{ color: "#333", marginBottom: 8 }}
          >
            Somente o <b>técnico do time</b> poderá resgatar este produto.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
